import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('remove_document', '/remove_documents', 'remove_document')
const actions = generator.generate()

export default actions
